import { Show } from "solid-js";

interface PaneHeaderProps {
  name: string;
  bytes: number;
  encoding: string;
  /** Detected language id, e.g. "typescript". `plaintext` and `undefined` are hidden. */
  lang?: string;
}

function formatBytes(n: number): string {
  if (n < 1024) return `${n} bytes`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

function showLang(lang: string | undefined): lang is string {
  return !!lang && lang !== "plaintext";
}

export function PaneHeader(p: PaneHeaderProps) {
  return (
    <div class="fd-pane-header-bar">
      <Show when={p.name.length > 0}>
        <span class="fd-pane-header-name">{p.name}</span>
      </Show>
      <span class="fd-pane-header-meta">
        <Show when={showLang(p.lang)}>
          <span class="fd-pane-header-lang">{p.lang}</span>
        </Show>
        <span>{formatBytes(p.bytes)} · {p.encoding}</span>
      </span>
    </div>
  );
}
